import './styles/main.css';
import { LogicLabApp } from './app/LogicLabApp';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('找不到 #app 根节点');

const app = new LogicLabApp(root);
app.start();

window.addEventListener('beforeunload', () => app.dispose());
